// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XtNR","newExpiryDate":"styles_newExpiryDate__2ql98","footer":"styles_footer__VwWeJ"};